import { render, staticRenderFns } from "./BriefEdit.vue?vue&type=template&id=a2890504&scoped=true"
import script from "./BriefEdit.vue?vue&type=script&lang=js"
export * from "./BriefEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2890504",
  null
  
)

export default component.exports